import { Box, CircularProgress } from '@mui/material';
import React from 'react';

const DialogLoader = () => {
    return (
        <Box className="dialog-loader">
            <CircularProgress size={24} />
        </Box>
    );
};

export default DialogLoader;
